export const formatDateToDefaultPosition = (date = Date.now()) =>
  Math.floor(new Date(date).getTime() - new Date('2016-09-01').getTime()) / 1000
